import script from "./salesDeclaration.vue?vue&type=script&setup=true&lang=js"
export * from "./salesDeclaration.vue?vue&type=script&setup=true&lang=js"

import "./salesDeclaration.vue?vue&type=style&index=0&id=34e7c176&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34e7c176"]])

export default __exports__